/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/


import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { updateComponent, getFromJson, formatBoolean } from '../util/Utils'
import Table from './Table';
import { linkFormatter } from '../util/LinkFormatter';
import PropTypes from 'prop-types';
import { LONG_REFRESH_INTERVAL } from '../constants'


function makeTableData(state) {
    return {
        job: {
            columns: ["Name", "#Rcpt", "#KBytes", "Domains", "Paused",
                      "Scheduled Start Time"],
            data: makeJobDetail(state),
            title: "Job Detail",
            domains: {
                columns: ["Name", "#Rcpt"],
                data: makeDomains(state),
                title: "Domains"
            },
            vmtas: {
                columns: ["Name", "#Rcpt"],
                data: makeVmtas(state),
                title: "Virtual MTAs"
            }
        }
    }
}


function makeJobDetail(state) {
    let j = getFromJson(state, ['data', 'data', 'job'])
    return j ? [[j.id, j.rcp, j.kb, j.dom, j.paused, j.scheduledStartTime]]
             : []
}


function makeDomains(state) {
    let domains = getFromJson(state, ['data', 'data', 'job', 'topDomains'], [])
    return domains.map((d) => {
        return [d.name, d.rcp]
    })
}


function makeVmtas(state) {
    let vmtas = getFromJson(state, ['data', 'data', 'job', 'topVmtas'], [])
    return vmtas.map((v) => {
        return [v.name, v.rcp]
    })
}


/**
 * JobDetail page of web monitor.
 */
export default class JobDetail extends Component {
    constructor(props) {
        super(props)
        this.refresh = this.refresh.bind(this)
        this.refreshInterval = this.refreshInterval.bind(this)
    }


    static propTypes = {
        job: PropTypes.string.isRequired,
        showError: PropTypes.func.isRequired,
        setRefresh: PropTypes.func.isRequired,
        setRefreshInterval: PropTypes.func.isRequired
    };


    async componentDidMount() {
        this.props.setRefresh(this.refresh)
        this.props.setRefreshInterval(this.refreshInterval)
        this.refresh()
    }


    refresh() {
        updateComponent(this, '/jobDetail', {
            jobid: this.props.job
        })
    }


    refreshInterval() {
        return LONG_REFRESH_INTERVAL
    }

    
    render() {
        let tables = makeTableData(this.state)
        let domainNameFormatter = {
            Name: linkFormatter.linkDomain
        }
        let vmtaNameFormatter = {
            Name: linkFormatter.linkVmta
        }
        let pausedFormatter = {
            Paused: formatBoolean
        }
        return (
            <Container>
                <Row>
                    <Col md={12}>{
                        <Table columns={tables.job.columns}
                               data={tables.job.data}
                               caption={tables.job.title}
                               columnFormatter={pausedFormatter}/>
                    }</Col>
                </Row>
                <Row>
                    <Col md={12}>{
                        <Table columns={tables.job.domains.columns}
                               data={tables.job.domains.data}
                               caption={tables.job.domains.title}
                               columnFormatter={domainNameFormatter}
                               sort={true}/>
                    }</Col>
                </Row>
                <Row>
                    <Col md={12}>{
                        <Table columns={tables.job.vmtas.columns}
                               data={tables.job.vmtas.data}
                               caption={tables.job.vmtas.title}
                               columnFormatter={vmtaNameFormatter}
                               sort={true}/>
                    }</Col>
                </Row>
            </Container>
        );
    }
}
